import { hasTauriRuntime } from './environment'

type DesktopRuntimeConfig = {
  BASE_API_URL?: string
  STORAGE_API_URL?: string
  AUTH_MODE?: string
  CONSOLE_URL?: string
  CONSOLE_SCOPED_INSTANCE?: string
  CONSOLE_ORGANIZATION_ID?: string
  FIXED_ORGANIZATION_ID?: string
  AUTH_HANKO_API_URL?: string
  INSTANCE_ID?: string
  INSTANCE_ORGANIZATION_ID?: string
  LIVEKIT_TARGETS?: string
  OPENUI_RUNTIME_ENABLED?: string
}

export function isTauriRuntimeAvailable() {
  return hasTauriRuntime()
}

async function getInvoke() {
  if (!hasTauriRuntime()) {
    return null
  }
  const module = await import('@tauri-apps/api/core')
  return module.invoke
}

export async function getDesktopRuntimeConfig(): Promise<DesktopRuntimeConfig | null> {
  const invoke = await getInvoke()
  if (!invoke) {
    return null
  }

  try {
    return await invoke<DesktopRuntimeConfig>('get_runtime_config')
  } catch {
    return null
  }
}

export async function openExternalUrl(url: string): Promise<boolean> {
  const normalized = url.trim()
  if (!normalized) {
    return false
  }

  const invoke = await getInvoke()
  if (invoke) {
    try {
      await invoke('open_external_url', { url: normalized })
      return true
    } catch {
      // Fallback below keeps the web build working even if the desktop bridge is unavailable.
    }
  }

  if (typeof window === 'undefined') {
    return false
  }

  const opened = window.open(normalized, '_blank', 'noopener,noreferrer')
  if (opened) {
    return true
  }

  window.location.assign(normalized)
  return true
}
